import { PageAccessRecipientRecord } from "models/view-models/page-access-recipient-record";
import ServiceHookFactory from "utilities/services/service-hook-factory";

export interface PageAccessRecipientBasePathParams {
    pageId: number;
}

export interface PageAccessRecipientResourcePathParams
    extends PageAccessRecipientBasePathParams {
    recipientId: number;
}

export interface CreatePageAccessRecipientPostParams {
    email: string;
    magicLink: string;
}

const baseEndpoint: string = "pages/:pageId/recipients";
const resourceEndpoint: string = `${baseEndpoint}/:recipientId`;
const resourceType = PageAccessRecipientRecord;

export const PageAccessRecipientService = {
    useCreate: ServiceHookFactory.useNestedCreateFromPostParams<
        PageAccessRecipientRecord,
        CreatePageAccessRecipientPostParams,
        PageAccessRecipientBasePathParams
    >(resourceType, baseEndpoint),
    useGetByPageId: ServiceHookFactory.useNestedList<
        PageAccessRecipientRecord,
        PageAccessRecipientBasePathParams,
        {}
    >(PageAccessRecipientRecord, baseEndpoint),
    useDelete: ServiceHookFactory.useDelete(resourceEndpoint),
};
